import { useState } from 'react';

const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
const GIPHY_API_URL = 'https://api.giphy.com/v1/gifs';

export default function useGiphy() {
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [gifs, setGifs] = useState([]);

  const fetchGifs = async (term) => {
    if (!term) {
      setGifs([]);
      return;
    }
    
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${GIPHY_API_URL}/search?api_key=${GIPHY_API_KEY}&q=${encodeURIComponent(term)}&limit=20&rating=g`
      );

      if (!response.ok) {
        throw new Error('Fehler beim Laden der GIFs');
      }

      const data = await response.json();
      setGifs(data.data || []);
    } catch (error) {
      console.error('GIPHY API Fehler:', error);
      setError('Fehler beim Laden der GIFs');
      setGifs([]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    searchTerm,
    setSearchTerm,
    isLoading,
    error,
    gifs,
    fetchGifs
  };
} 